import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IconeTituloContainerService } from './icone-titulo-container.service';
import { IconeTituloData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-icone-titulo-container',
  template: `
    <fcp-icone-titulo
      [iconeTitulo]="data | async"
    ></fcp-icone-titulo>
  `
})
export class IconeTituloContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<IconeTituloData>;
  constructor(private iconeTituloContainerService: IconeTituloContainerService) {}

  ngOnInit() {
    this.data = this.iconeTituloContainerService.getIconeTitulo(this.id);
  }
}
